(()=>{
 if(window.KeithAddonCards)return;window.KeithAddonCards=true;
 // Delegate only card whitespace. Links, checkboxes and option controls keep native behavior.
 document.addEventListener('click',e=>{
  if(e.defaultPrevented||e.target.closest('a,button,input,select,label,[role="button"],[role="link"],lb-card-image,lb-card-title,card-checkbox'))return;
  const card=e.target.closest('[data-k2-product] .kp-list .kp-row,[data-k2-product] [widget="widget#pal"] .lb-flat-card');
  if(!card)return;
  const check=card.querySelector('[data-kp-check],.lb-card-checkbox');
  if(check&&!check.disabled)check.click();
 });
})();

(()=>{
 if(window.KeithMorePairings)return;window.KeithMorePairings=true;
 function updateLabel(details){
  const label=details.querySelector('[data-kp-more-label]');if(!label)return;
  const total=details.querySelectorAll('[data-pairing-card]').length;
  const selected=details.querySelectorAll('[data-kp-check]:checked').length;
  label.textContent=selected?`More pairings (${total}) · ${selected} selected`:`More pairings (${total})`;
 }
 const mobile=window.matchMedia('(max-width:989px)');
 const originalPositions=new WeakMap();
 function arrange(root){
  const form=root.querySelector('[data-k2-product-form]');
  const buy=form?.querySelector('.k2-buy-row');if(!buy)return;
  const widgets=[...form.querySelectorAll('[widget="widget#pal"]')];
  const appBlocks=[...new Set(widgets.map(w=>w.closest('[data-k2-app-block]')).filter(Boolean))];
  const lists=[...form.querySelectorAll('.kp-list')];
  const blocks=[...appBlocks,...lists];
  blocks.forEach(block=>{
   if(!originalPositions.has(block)){
    const marker=document.createComment('KEITH add-on original position');
    block.before(marker);
    originalPositions.set(block,marker);
   }
  });
  if(mobile.matches){
   let anchor=buy;
   blocks.forEach(block=>{
    // Keep existing mobile placement, native nodes and app listeners.
    block.setAttribute('data-k2-addon-positioned','');
    if(anchor.nextElementSibling!==block)anchor.after(block);
    anchor=block;
   });
  }else{
   blocks.forEach(block=>{
    const marker=originalPositions.get(block);
    if(marker?.parentNode && marker.nextSibling!==block)marker.after(block);
    block.removeAttribute('data-k2-addon-positioned');
   });
  }
  lists.forEach(list=>{
   const details=list.querySelector('[data-kp-more]');if(!details)return;
   // If no Selleasy offer exists, do not leave all recommendations hidden.
   if(!details.dataset.kpUserToggled)details.open=widgets.length===0;
   updateLabel(details);
  });
 }
 function boot(scope){
  const roots=scope.matches?.('[data-k2-product]')?[scope]:scope.querySelectorAll('[data-k2-product]');
  roots.forEach(root=>{
   arrange(root);
   if(root.dataset.kpMoreObserved)return;root.dataset.kpMoreObserved='true';
   let scheduled=false;
   const observer=new MutationObserver(records=>{
    // Ignore text-label updates. Watch for delayed Selleasy injection, removal or rerender.
    if(!records.some(r=>[...r.addedNodes,...r.removedNodes].some(n=>n.nodeType===1)))return;
    if(scheduled)return;scheduled=true;
    requestAnimationFrame(()=>{scheduled=false;if(root.isConnected)arrange(root);});
   });
   observer.observe(root,{childList:true,subtree:true});
   root.addEventListener('shopify:section:unload',()=>observer.disconnect(),{once:true});
  });
 }
 document.addEventListener('click',e=>{const summary=e.target.closest('.kp-more>summary');if(summary)summary.parentElement.dataset.kpUserToggled='true';});
 document.addEventListener('change',e=>{const details=e.target.closest('[data-kp-more]');if(details)updateLabel(details);});
 document.addEventListener('shopify:section:load',e=>boot(e.target));
 if(mobile.addEventListener)mobile.addEventListener('change',()=>boot(document));
 else mobile.addListener(()=>boot(document));
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>boot(document),{once:true});else boot(document);
})();
